import { faPlus } from '@fortawesome/pro-solid-svg-icons'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from "react-i18next";
import { useGetOrganisationsQuery } from '../../../../../Redux/Api/Organisations';
import Button from '../../../../Shared/Form/Button'
import Title from '../../../../Shared/Title'
import LoadingPage from '../../../LoadingPage'
import RowActions, { RowAction } from '../../../../Datagrid/DatagridLayout/Rows/RowActions';
import GenericDatagrid from '../../../../Datagrid/GenericDatagrid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faHome, faEye, faEyeSlash } from '@fortawesome/pro-light-svg-icons';
import { useContext } from 'react';
import { useAppSelector } from '../../../../../Redux/store';
import { ModalContext } from '../../../../Shared/Modal/Modal';
import ImageRenderer from '../../../../Datagrid/Renderers/ImageRenderer';

const OrganisationsList = () => {

    const navigate = useNavigate()
    const { t, i18n } = useTranslation()
    const hidden = { hidden: 'false' };

    const org_id = useAppSelector((s) => s.organisation.id);
    const modal = useContext(ModalContext);

    const { data: organisations, } = useGetOrganisationsQuery(hidden, {
        refetchOnMountOrArgChange: true
    });

    const setOrg = async (id: string) => {
        if (id === org_id) return;
        if (!(await modal.show(t('admin:switchOrganizationWarningTitle'), t('admin:switchOrganizationWarningMessage')))) {
            modal.hide();
            return;
        }
        modal.hide();
        localStorage.setItem('active_organisation', id);
        window.location.reload();
    };

    const columns = [
        {
            field: 'image',
            headerName: '',
            renderCell: (params: any) => (
                <ImageRenderer src={params.row.settings.theme.icon} alt={params.row.name} />
            ),
            maxWidth: 60,
            minWidth: 60,
            filterable: false,
        },
        {
            field: "hidden",
            headerName: "",
            width: 40,
            renderCell: (params: any) => {
                return <FontAwesomeIcon icon={params.row.hidden ? faEyeSlash : faEye} />;
            },
        },
        {
            field: 'id',
            headerName: 'Id',
            flex: 1,
        },
        {
            field: 'name',
            headerName: t("admin:name"),
            flex: 1,
        },
        {
            field: "activeCardsCount",
            headerName: t("admin:activeCards"),
            renderCell: (params: any) => {
                return <span className={`${params.value > 0 ? 'text-green-500' : 'text-red-500'} font-bold`}>{params.value}</span>
            },
            flex: 1,
        },
        {
            field: 'actions',
            headerName: '',
            width: 120,
            renderCell: (params: any) => {
                const actions: RowAction[] = [
                    {
                        label: t('switchOrganization'),
                        icon: <FontAwesomeIcon icon={faHome} />,
                        onClick: () => setOrg(params.row.id),
                    },
                    {
                        label: t('cards:list:adjust'),
                        icon: <FontAwesomeIcon icon={faEdit} />,
                        onClick: () => navigate(`/${i18n.language}/dashboard/admin/organisation/edit/` + params.row.id),
                    }
                ];

                if (params.row.id === org_id) {
                    actions.splice(0, 1);
                }

                return <RowActions actions={actions} />;
            },
        }
    ];

    if (!organisations) return <LoadingPage />

    return (
        <>
            <div className='flex flex-col lg:flex-row justify-between items-start lg:items-center'>
                <Title text={t('organisation:organisations')} textNotBold />
                <Button action={() => navigate(`/${i18n.language}/dashboard/admin/organisation/create`)} className='my-6' title={t("admin:addOrganization")} icon={faPlus} iconright />
            </div>

            <GenericDatagrid
                data={organisations}
                columns={columns}
                onRowClick={(params: any) => navigate(`/${i18n.language}/dashboard/admin/organisation/edit/` + params.row.id)}
                className='mb-5 lg:mb-10'
                disableHeaderCells={['image', 'hidden']}
            />
        </>
    )
}

export default OrganisationsList
